import { SharedTradeInterface } from '../ng-services/social-trading/trade-sharing.store';
import { parseTradeSetupOrders } from './shared-trade.util';
import { getSharedTradeStrategy } from './get-shared-trade-strategy';

export enum SharedTradeDirection {
    LONG,
    SHORT,
    UNSPECIFIED,
}

function getPostContent(trade: SharedTradeInterface) {
    return trade.posts?.length ? trade.posts?.[0]?.content : '';
}

export function getSharedTradeDirection(trade: SharedTradeInterface) {
    const postContent = getPostContent(trade);
    const strategy = getSharedTradeStrategy(trade) ?? '';

    // todo: this should be handled using setup file
    // but for now there is not enough information to do it in the setup file

    const getTypeFromPost = () => {
        const shortTradeRegex = /Short Trade \d+@[\d,]+;/gm;
        const longTradeRegex = /Long Trade \d+@[\d,]+;/gm;

        if (postContent?.match(shortTradeRegex)) {
            return SharedTradeDirection.SHORT;
        }

        if (postContent?.match(longTradeRegex)) {
            return SharedTradeDirection.LONG;
        }
        return SharedTradeDirection.UNSPECIFIED;
    };

    const typeFromPost = getTypeFromPost();

    // return type for manual trades
    // for AT trades - return only if not unspecified
    if (trade.type === 'Manual' || typeFromPost !== SharedTradeDirection.UNSPECIFIED) {
        // handle manual strategy
        return typeFromPost;
    }

    // try to figure out the type
    const orders = parseTradeSetupOrders(trade?.setup_file?.orders || []);

    // find order matching strategy
    const target = orders.find((order) => order.orderName === strategy);

    if (!target) {
        return SharedTradeDirection.UNSPECIFIED;
    }

    return target.isSellOrder ? SharedTradeDirection.SHORT : SharedTradeDirection.LONG;
}
